<template>
  <div class="main-container">
    <breadcrumb :list="breadcrumbList" />
    <tl-header class="header-space" type="h1">
      <div class="main-header">Increment Arrear Override</div>
    </tl-header>
    <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission">
      You have only view permission.
    </div>
    <div class="essStatus" :disabled="!ifTeamleaderAnchorPermission">
      <div class="flex radio-group radio-margin-bot">
        <tl-radio
          name="uploadType"
          label="Bulk Upload"
          id="bulkUpload"
          value="bulkUpload"
          v-model="uploadMethod"
        />
        <tl-radio
          name="uploadType"
          label="Manual"
          id="manualUpload"
          value="manualUpload"
          v-model="uploadMethod"
        />
      </div>
      <div class v-if="uploadMethod == 'manualUpload'">
        <div class="row">
          <div class="col-3">
            <tl-select labelText="name" name="fy" label="Financial Year" :options="financialYear" />
          </div>
          <div class="col-3">
            <tl-select label="Month" name="month" :options="effMonthOptions" />
          </div>
        </div>
        <div class="row margin-t-m">
          <div class="col-3">
            <tl-select
              label="Criteria"
              name="criteria"
              :options="['Locations', 'Paygroups', 'Cost Centres', 'Bands', 'Grades', 'Designations']"
              @change="onCriteriaSelect($event)"
            />
          </div>
          <div class="col-3" v-if="subCriteriaLabel">
            <tl-select
              labelText="name"
              name="sub_criteria"
              :label="subCriteriaLabel"
              :options="subCriteriaList"
            />
          </div>
        </div>
        <btn text="Apply Filters" type="secondary" class="apply-filter-btn"></btn>
        <div class="row margin-t-m margin-b-m">
          <div class="col-12">
            <search-dropdown
              label="Select Employee"
              :employeeData="customEmpList"
              @getList="searchEmployeesByName($event)"
              @empselected="(emp)=>selectedEmp(emp)"
            />
          </div>
        </div>
        <data-table :columns="employeeTableColumns" :tableData="employeeData" :showinrow="false">
          <template v-slot:rowcontent="slotprops">
            <img
              class="sm-img text-center"
              v-if="slotprops.value.column.key=='imgSrc'"
              :src="slotprops.value.record[slotprops.value.column.key]"
            />
            <p
              v-if="slotprops.value.column.key!='imgSrc'"
            >{{slotprops.value.record[slotprops.value.column.key]}}</p>
            <a
              class="link"
              href="javascript:void(0)"
              v-if="slotprops.value.column.key=='action'"
              @click="override()"
            >Override</a>
          </template>
        </data-table>
      </div>
      <div class v-else>
        <div class="margintop-2p">
          <download-button></download-button>
        </div>
        <div class="margintop-2p">
          <upload />
        </div>
      </div>
    </div>
    <bottom-action-container >
      <template slot="end">
        <btn-grp>
          <btn text="Back" type="secondary" @click="back" />
          <btn text="Upload" v-if="uploadMethod != 'manualUpload'" type="primary" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import SearchDropdown from "@/components/TlSearchDropdown.vue";
export default {
  components: {
    SearchDropdown
  },
  data() {
    return {
      uploadMethod: "manualUpload",
      breadcrumbList: [
        {
          name: "Payroll",
          url: `/dashboard/${this.$route.params.entity_index}/payroll`
        },
        {
          name: "Utilities",
          url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities`
        },
        {
          name: "Increment Arrear Override",
          url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/increment_arrears`
        }
      ],
      formData: {},
      financialYear: [
        {
          name: "2017-18",
          value: "2017"
        },
        {
          name: "2018-19",
          value: "2018"
        },
        {
          name: "2019-20",
          value: "2019"
        },
        {
          name: "2020-21",
          value: "2020"
        }
      ],
      effMonthOptions: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      customEmpList: [],
      subCriteriaList: [],
      subCriteriaLabel: "",
      employeeTableColumns: [
        {
          label: "",
          key: "imgSrc"
        },
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Month",
          key: "month"
        },
        {
          label: "Components",
          key: "components"
        },
        {
          label: "Amount",
          key: "amount"
        },
        {
          label: "Override Amount",
          key: "overrideAmount"
        },
        {
          label: "Action",
          key: "action"
        }
      ],
      employeeData: [
        {
          id: 1,
          code: "RC1234",
          name: "Roxi",
          month: "All",
          components: "All",
          amount: "10000",
          overrideAmount: "1000",
          imgSrc: require("@/assets/user.svg"),
          action: ""
        }
      ],
      incrementArrearOverrideValue: false,
      role: ""
    };
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    ifTeamleaderAnchorPermission() {
        if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
          if(this.incrementArrearOverrideValue) {
            return true;
          } else {
            return false;
          }
        } 
        // else {
        // return true 
        // }
    }
  },
  activated() {
    // this.getLocations();
    this.getOrgLeIdList();
  },
  methods: {
    ...mapActions({
      act_fetchPaygroups: "dashboard/payroll/monthlypayroll/payGroup/fetchAll",
      fetch_paygroups: "onboard/paygroup/fetchAll",
      fetch_locations: "onboard/locations/fetchAll",
      fetch_grades: "onboard/salary_grades/fetchAll",
      fetch_bands: "onboard/salary_bands/fetchAll",
      fetch_businessunits: "onboard/business_units/fetchAll",
      fetch_cost_center: "onboard/cost_centres/fetchAll",
      fetch_designation: "onboard/designations/fetchAll",
      fetchEmployees: "globalapi/globalemployees/fetchAll",
      fetchEmployeeByName: "globalapi/globalemployees/fetchByName"
    }),

    async getLocations() {
      try {
        let res = await this.fetch_locations(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getBands() {
      try {
        let res = await this.fetch_bands(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getPaygroups() {
      try {
        let res = await this.fetch_paygroups(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getDepartment() {
      try {
        let res = await this.fetch_businessunits(this.orgId);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getCostCenter() {
      try {
        let res = await this.fetch_cost_center(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getDesignations() {
      try {
        let res = await this.fetch_designation(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getGrades() {
      try {
        let res = await this.fetch_grades(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        //console.log(error);
      }
    },
    onCriteriaSelect(event) {
      if (event == "Locations") {
        this.subCriteriaLabel = "Location";
        this.getLocations();
      } else if (event == "Paygroups") {
        this.subCriteriaLabel = "Paygroup";
        this.getPaygroups();
      } else if (event == "Cost Centres") {
        this.subCriteriaLabel = "Cost Centre";
        this.getCostCenter();
      } else if (event == "Bands") {
        this.subCriteriaLabel = "Band";
        this.getBands();
      } else if (event == "Grades") {
        this.subCriteriaLabel = "Grade";
        this.getGrades();
      } else if (event == "Designations") {
        this.subCriteriaLabel = "Designation";
        this.getDesignations();
      } else {
        this.subCriteriaLabel = "Sub Criteria";
      }
    },
    async searchEmployeesByName(val) {
      try {
        let res = await this.fetchEmployeeByName(val);
        this.customEmpList = res.data.payload.data;
      } catch (error) {
        //console.log(error);
      }
    },

    selectedEmp(obj) {
      //console.log(obj);
    },
    back() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities`
      });
    },
    override() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/override_increment`
      });
    },

    ...mapActions({
        getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    async getOrgLeIdList() {
        const org = this.orgId;
        const le = this.le_id;
        //console.log("Org:",org);
        //console.log("Le ID",le);
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
            ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.incrementArrearOverrideValue = data.data.user.permissions.increment_arrear_override ? true : false;
        //console.log("PL-3406",data);
    }
  }
};
</script>
<style lang="scss" scoped>
.sm-img {
  width: 35%;
  align-content: center;
}
.link {
  font-size: 14px;
}
.header-space {
  margin: 18px 0px 10px 0px;
}
.radio-margin-bot {
  margin-bottom: 3.4%;
}
.filter-margin-bot {
  margin-bottom: 1.4%;
}
.apply-filter-btn {
  margin-top: 20px;
  padding: 0px;
  min-height: 35px;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
